/* eslint-disable max-len */
import React from 'react';

export default function PDFIcon() {
  return (
    <svg width="39" height="52" fill="none" viewBox="0 0 39 52">
      <path
        fill="url(#paint0_linear_10353_4397)"
        fillRule="evenodd"
        d="M6.77 0h17.385l14.734 15.358V45.23c0 3.742-3.027 6.77-6.756 6.77H6.77A6.765 6.765 0 010 45.23V6.77A6.765 6.765 0 016.77 0z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M24.142 0v15.241h14.747L24.142 0z"
        clipRule="evenodd"
        opacity="0.302"
      />
      <path
        fill="#fff"
        d="M7.523 38.799V29.3h4.041c1 0 1.793.273 2.391.832.598.546.897 1.286.897 2.209 0 .922-.3 1.663-.897 2.209-.598.559-1.39.831-2.39.831H9.952V38.8h-2.43zm2.43-5.483h1.338c.364 0 .65-.079.845-.26.195-.17.299-.403.299-.715 0-.312-.104-.546-.3-.715-.194-.182-.48-.26-.844-.26H9.953v1.95zm5.899 5.483V29.3h3.365c.663 0 1.287.091 1.871.286a5.03 5.03 0 011.586.845c.467.364.844.857 1.117 1.481.26.624.403 1.339.403 2.144a5.51 5.51 0 01-.403 2.131c-.273.624-.65 1.117-1.117 1.481-.468.377-1 .65-1.586.845a5.878 5.878 0 01-1.87.286h-3.366zm2.378-2.066h.701c.377 0 .728-.04 1.053-.13.312-.091.61-.234.896-.429.273-.195.494-.468.65-.832.156-.363.234-.792.234-1.286 0-.507-.078-.935-.234-1.3a1.926 1.926 0 00-.65-.83 3.156 3.156 0 00-.896-.43 3.892 3.892 0 00-1.053-.13h-.701v5.367zm7.185 2.066V29.3h6.757v2.066h-4.327v1.52h3.456v2.054h-3.456v3.859h-2.43z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10353_4397"
          x1="19.445"
          x2="19.445"
          y1="0"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F35256" />
          <stop offset="1" stopColor="#E31F24" />
        </linearGradient>
      </defs>
    </svg>
  );
}
